import * as React from "react";

function RocketIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M408 143.1c0 23-17.9 40-40 40s-40-17-40-40c0-21.2 17.9-40 40-40s40 18.8 40 40zM23.1 288c-7.72 0-15.686-4.6-19.955-12.1a23.963 23.963 0 0 1 .211-24.1l52.474-88.5c12.96-21.9 36.5-36.2 61.97-36.2h82.1c2.5-3.1 4.9-6.8 7.3-10.4C289.1-4.07 411.1-8.142 483.9 5.275c11.7 2.139 20.7 11.155 22.8 22.785 13.4 72.84 9.4 194.84-111.4 276.74-3.6 2.4-8.2 4.8-11.3 7.3v82.1c0 25.5-13.4 49-35.3 62l-88.5 52.4c-7.4 4.4-16.6 4.5-24.1.3-7.5-4.3-13-12.3-13-20.9v-96.2c-7.9 3.8-15.7 7.1-23 9.9-11 4.9-24.6 2.2-33.6-6.9l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9 2.6-6 5.8-13.2 9.4-21.2H23.1zM461.7 50.32c-63.3-8.47-152.6.78-215.6 93.38-29.3 44.4-68 128.2-88.5 174.4l35 35c46.5-19.9 131.3-57.9 175.7-88.1 91.7-62.1 101.9-151.4 93.4-214.68z"
  }));
}

const ForwardRef = React.forwardRef(RocketIcon);
export default ForwardRef;